module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shadow"
  }, [_c('img', {
    staticClass: "arrow",
    attrs: {
      "src": require("../../assets/images/new-login-2018/arrow@2x.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "h20"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/one@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/select@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text2))])]), _vm._v(" "), _c('div', {
    staticClass: "h20 mt10"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/two@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text3))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/Browser@2x.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text4))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a656a44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Shadow.vue
// module id = 788
// module chunks = 1